import React from 'react'
import Pt from 'prop-types'
import cx from 'classnames'

import Icon from 'internal-components/src/components/Icon'
import { SignupWithExternalsRecord } from 'internal-components/src/records'

import './ProgressDiagram.css'

// Displays
export default function ProgressDiagram({ signupWithExternals }) {
  const stateProgression = ['submitted', 'qualifying', 'ordered', 'pending-install', 'installed', 'active'];
  const stateNames = ['Submitted', 'Qualifying', 'Ordered', 'Pending Install', 'Installed', 'Active'];
  const transitionByState = {};
  let maxProgress = 'submitted', maxIndex = 0;
  signupWithExternals.signup.get('stateTransitions').forEach(transition => {
    let state = transition.get('toState');
    const index = stateProgression.indexOf(state);
    if (index > -1 && index > maxIndex) {
      maxProgress = transition.get('toState');
      maxIndex = index;
    }
    if (!transitionByState.hasOwnProperty(state)) {
      transitionByState[state] = transition;
    }
  });

  return (
    <div className="signup-progress-track">
      {stateProgression.map((stateKey, index) => <div key={stateKey} className={cx('signup-progress-item', {checked: index <= maxIndex})}>
        <div className="signup-progress-item-inner">
          <div className="signup-progress-item-name">{stateNames[index]}</div>
          <div className={cx('signup-progress-icon', {checked: index <= maxIndex})}></div>
          {transitionByState[stateKey] && <div className="signup-progress-completion-date">
            Completed<br />
            {transitionByState[stateKey].dateAdded.format('D MMM YYYY')}
          </div>}
        </div>
      </div>)}
    </div>
  );
}

ProgressDiagram.propTypes = {
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/SignupDetails/ProgressDiagram.jsx